<template>
  <div>
    <vs-row>
      <div class="vx-col w-full lg:w-2/3 mb-base px-5">
        <vx-card slot="no-body" class="text-center greet-user p-5">
          <div class="vx-row">
            <div class="vx-col lg:w-1/3 mb-base">
              <feather-icon
                icon="HomeIcon"
                class="
                  p-6
                  mb-8
                  bg-primary
                  inline-flex
                  rounded-full
                  text-white
                  shadow
                "
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2">{{ numNormal }} venues</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto">up-to-date</p>
            </div>
            <div class="vx-col lg:w-1/3 mb-base">
              <feather-icon
                icon="ClockIcon"
                class="
                  p-6
                  mb-8
                  bg-warning
                  inline-flex
                  rounded-full
                  text-white
                  shadow
                "
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2">{{ numWarning }} venues</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto">
                without updated AP for {{ WARNING_THRESHOLD }}+ days (Warning)
              </p>
            </div>
            <div class="vx-col lg:w-1/3 mb-base">
              <feather-icon
                icon="AlertCircleIcon"
                class="
                  p-6
                  mb-8
                  bg-danger
                  inline-flex
                  rounded-full
                  text-white
                  shadow
                "
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2">{{ numCritical }} venues</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto">
                without updated AP for {{ CRITICAL_THRESHOLD }}+ days (Critical)
              </p>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/3 mb-base px-5">
        <vx-card slot="no-body" class="greet-user">
          <h1 class="mb-2">Filters</h1>
          <vs-select label="Country" class="mb-2" v-model="filterCountry">
            <vs-select-item
              :key="item"
              :value="item"
              :text="item"
              v-for="item in countryList"
            />
          </vs-select>
          <vs-select label="AP status" v-model="filterStatus">
            <vs-select-item
              :key="item"
              :value="item"
              :text="item"
              v-for="item in apStatusList"
            />
          </vs-select>
        </vx-card>
      </div>
    </vs-row>
    <vs-row>
      <vs-col>
        <FullCalendar
          :options="{
            ...calendarOptions,
            events: mapEvents,
            resources: mapResources,
          }"
          ref="fullCalendar"
        />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import { mapGetters } from "vuex";
import moment from "moment";
import { rrulestr } from "rrule";

export default {
  components: {
    FullCalendar,
  },
  data() {
    return {
      countryList: ["All", "Danmark", "Norge", "Finland"],
      filterCountry: "All",
      apStatusList: ["All", "Critical", "Warning", "Normal"],
      filterStatus: "All",
      budgetIncrementers: [0, 0, 0, 0, 0, 0],
      budgetSetMode: false,
      calendarOptions: {
        schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
        plugins: [resourceTimelinePlugin],
        initialView: "resourceTimelineMonth",
        aspectRatio: 1.6,
        headerToolbar: {
          left: "",
          center: "title",
          right: "prev,next",
        },
        resourcesInitiallyExpanded: false,
        resourceGroupField: "venueName",
        resourceAreaWidth: "30%",
        resourceAreaColumns: [
          {
            field: "title",
            headerContent: "Type",
            width: 140,
          },
          {
            field: "lastEdited",
            headerContent: "Last edited",
          },
        ],
        eventDidMount: function (info) {
          // tippy(info.el, {
          //   content: info.event.extendedProps.popupContent,
          //   zIndex: 99999,
          // });
        },
        resourceGroupLabelClassNames: function (info) {
          // info.el.id = info.groupValue;
          // console.log(this.venues.find((e) => e.name == info.groupValue));
          // return "resource-critical";
        },
        resourceGroupLabelDidMount: function (info) {
          // Set the id to the name of the venue, so it can be found in DOM later
          info.el.id = info.groupValue;
          // console.log(info);
        },
        resourceGroupLaneDidMount: function (info) {},
        eventMaxStack: 0,
        nowIndicator: true,
      },
      addNewEventPrompt: false,
      calendarApi: null,
      calendarTitle: "",
      calendarMonth: "",
      editComment: null,
      isEditingComment: false,
      calendarMonthNumber: 0,
      calendarYear: "",
      initialLoadCompleted: false,
      numNormal: 0,
      numWarning: 0,
      numCritical: 0,
      WARNING_THRESHOLD: 7,
      CRITICAL_THRESHOLD: 14,
    };
  },
  async mounted() {
    this.$vs.loading();
    this.calendarApi = this.$refs.fullCalendar.getApi();

    //await this.$store.dispatch("venues/ensureUserVenues"); //ensureUserVenues
    //await this.$store.dispatch("users/ensureMe");
    await this.$store.dispatch("activationPlan/getEvents", "*");
    await this.$store.dispatch("activationPlan/getChangeLog");

    console.log(this.calendarApi);
    this.addResourcesColor();
    this.initialLoadCompleted = true;

    this.$vs.loading.close();
  },
  methods: {
    addResourcesColor() {
      // Timeout because FullCalendar needs to complete a potential rerender first
      setTimeout(() => {
        this.numNormal = 0;
        this.numWarning = 0;
        this.numCritical = 0;
        // Check the changelog and paint the venues according to their last change date
        this.filteredVenues.forEach((e) => {
          const element = document.getElementById(e.name);
          let label = e.latestLog
            ? moment(e.latestLog.timestamp).fromNow()
            : "Never";

          if (!element) {
            console.error("element NOT FOUND");
            return;
          }

          if (e.daysDifference >= this.CRITICAL_THRESHOLD) {
            element.classList.add("resource-critical");
            this.numCritical++;
          } else if (e.daysDifference >= this.WARNING_THRESHOLD) {
            element.classList.add("resource-warning");
            this.numWarning++;
          } else {
            this.numNormal++;
          }

          const insertElement = document.createElement("span");
          insertElement.textContent = label;
          insertElement.className = "fc-customLabel";

          const parentElement = element.firstChild.firstChild;
          if (parentElement) {
            // Remove all current labels
            parentElement
              .getElementsByClassName("fc-customLabel")
              .forEach((e) => e.remove());
            // and replace by the newest one
            parentElement.appendChild(insertElement);
          }
        });
      }, 1);
    },
    eventTypeToColor(type) {
      switch (type) {
        case 0:
          return "#29c76f";
        case 1:
          return "#FF9F43";
        case 2:
          return "#7167e8";
        default:
          return "#aa0000";
      }
    },
  },

  computed: {
    ...mapGetters({
      events: "activationPlan/events",
      activeVenue: "venues/activeVenue",
      venues: "venues/venues",
      changeLog: "activationPlan/changeLog",
    }),
    filteredVenues() {
      return this.venues
        .map((e) => {
          const venueChangeLog = this.changeLog.filter(
            (c) => e.venueId === c.venueId
          );

          // Sort by latest edit
          venueChangeLog.sort(
            (a, b) => new Date(b.time).getTime() - new Date(a.time).getTime()
          );

          if (venueChangeLog.length == 0) {
            return { ...e, daysDifference: 999, latestLog: null };
          }

          const latestLog = venueChangeLog[venueChangeLog.length - 1];
          const daysDifference = moment().diff(
            moment(latestLog.timestamp),
            "days"
          );

          return { ...e, daysDifference, latestLog };
        })
        .filter((e) => {
          if (this.filterCountry === "All") return e;
          return this.filterCountry === e.country;
        })
        .filter((e) => {
          if (this.filterStatus === "All") return e;
          switch (this.filterStatus) {
            case "All": {
              return e;
            }
            case "Critical": {
              return e.daysDifference >= this.CRITICAL_THRESHOLD;
            }
            case "Warning": {
              return (
                e.daysDifference >= this.WARNING_THRESHOLD &&
                e.daysDifference < this.CRITICAL_THRESHOLD
              );
            }
            case "Normal": {
              return e.daysDifference < this.WARNING_THRESHOLD;
            }
            default: {
              return e;
            }
          }
        });
    },
    mapResources() {
      const resourceList = [];
      this.filteredVenues.forEach((e) => {
        const eventTypesInfo = [
          {
            id: 0,
            title: "Activities",
            typeName: "ActivationPlanEvent",
          },
          {
            id: 1,
            title: "Social",
            typeName: "ActivationPlanSMC",
          },
          {
            id: 2,
            title: "Paid Media",
            typeName: "ActivationPlanPaidMedia",
          },
        ];

        eventTypesInfo.forEach((info) => {
          // Find the last change
          const venueChangeLog = this.changeLog
            .filter((c) => e.venueId === c.venueId && c.type === info.typeName)
            .map((e) => ({ ...e, time: new Date(e.timestamp).getTime() }));

          let lastEdited = "Never edited";
          venueChangeLog.sort((a, b) => b.time - a.time);
          if (venueChangeLog.length != 0) {
            const dateTime = moment(venueChangeLog[0].time).format(
              "DD/MM HH:mm"
            );
            lastEdited = `${dateTime} by ${venueChangeLog[0].displayName}`;
          }

          resourceList.push({
            id: `${e.venueId}__${info.id}`,
            title: info.title,
            venueName: `${e.name}`,
            lastEdited: lastEdited,
          });
        });
      });
      if (this.initialLoadCompleted) this.addResourcesColor();
      return resourceList;
    },

    mapEvents() {
      return this.events.map((e) => {
        const nE = {
          id: e.activationPlanEventId,
          // title: e.title,
          description: e.description,
          popupContent: e.description === "" ? e.title : e.description,
          color: this.eventTypeToColor(e.type),
          resourceId: `${e.venueId}__${e.type}`,
          allDay: true,
        };

        // Try to parase the rrule first, and ensure it is valid, otherwise treat it as non-recurring
        let isRecurringOverride = false;
        try {
          if (e.isRecurring) {
            rrulestr(e.rRule, { forceset: true });
            isRecurringOverride = true;
          }
        } catch (err) {
          isRecurringOverride = false;
        }

        const endDate = new Date(e.endDateUtcTicks);
        endDate.setDate(endDate.getDate() + 1); // Add +1 because endDate is EXCLUSIVE when allDay=true
        return isRecurringOverride
          ? {
              ...nE,
              rrule: e.rRule,
              exdate: rrulestr(e.rRule, { forceset: true })
                .exdates()
                .map((e) => moment(e).format("YYYYMMDD")),
            }
          : {
              ...nE,
              start: new Date(e.startDateUtcTicks),
              end: endDate,
            };
      });
    },
  },
};
</script>

<style lang="scss">
.fc-customLabel {
  float: right;
}

.fc-timeline-more-link {
  display: none;
}
.resource-critical {
  background-color: rgb(255, 170, 170) !important;
  font-weight: bold;
}
.resource-warning {
  background-color: rgb(255, 255, 170) !important;
  font-weight: bold;
}
</style>
